import { render } from "./FaqQuestion.vue?vue&type=template&id=204b23d2&scoped=true"
import script from "./FaqQuestion.vue?vue&type=script&lang=js"
export * from "./FaqQuestion.vue?vue&type=script&lang=js"

import "./FaqQuestion.vue?vue&type=style&index=0&id=204b23d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-204b23d2"

export default script